import React, { useEffect, useRef, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { STituloDivider, IconTransfer } from './styles';
import SelectDinamico from '../../../components/SelectDinamico';
import ConsultaAprovadorSC from '../../../../lib/json/consultas/AprovadoresGoEvo.json'
import ConsultaAprovadores from '../../../../lib/json/consultas/AprovadoresProtheus.json'
import GrupoAprovacao from '../../../../lib/json/consultas/GrupoAprovacao.json'
import TitlePage from '../../../components/TitlePage';
import SelectFixo from '../../../components/SelectFixo';
import { ErroMsg, SucessoMsg } from '../../../contents/VariaveisGlobais';
import ConsumoTOTVS_POST from '../../../../backend/ConsumoTotvs';
import LoadingSpinner from '../../../components/LoadinSpinner';
import ResponsiveDataTable from '../../../components/DataTable';
import { ConsultaTotvsEmpresa } from '../../../../backend/ConsultaTotvsEmpresa';

function AjustaAprovadores(){
    const [aprovadorSCOrigem, setAprovadorSCOrigem] = useState({value: '', label: 'Selecione'});
    const [aprovadorSCDestino, setAprovadorSCDestino] = useState({value: '', label: 'Selecione'});
    const [aprovadorOrigem, setAprovadorOrigem] = useState({value: '', label: 'Selecione'});
    const [carregar, setCarregar] = useState(false);
    const [dataGrupoAprovacao, setDataGrupoAprovacao] = useState([]);
    var selectValues = [];

    var formatColumnManutencao = (item) =>{
        if (selectValues.filter( (value) => value.GRUPOAPROVACAO == item.row.values.AL_COD ).length == 0){
            selectValues.push({GRUPOAPROVACAO: item.row.values.AL_COD, APROVADORTIPO: '', APROVADORNEW: '' });
        }
        
        const options = [
            {
                value: 'N',
                text: "Sem Manutenção",
            },
            {
                value: 'P',
                text: "Substituir na Aprovação",
            },
            {
                value: 'S',
                text: "Substituir no Grupo",
            },
            {
                value: 'R',
                text: "Remover do Grupo",
            }
        ];
    
    
        const handleChangeSelect = (selectOption, AL_COD) => {
            selectValues.filter( (value) => value.GRUPOAPROVACAO == AL_COD )[0].APROVADORTIPO = selectOption.value
        }

        return (<SelectFixo
                        options={options} 
                        isLabel={true}
                        onChange={(selectedOption) => {handleChangeSelect(selectedOption, item.row.values.AL_COD)}}
                    />
        );
    }

    var formatColumnNewAprovador = (item) =>{
        const campoTipo = selectValues.filter( (value) => value.GRUPOAPROVACAO == item.row.values.AL_COD )[0].APROVADORTIPO
        
        const handleChangeSelectAprovador = (selectOption, AL_COD) => {
            selectValues.filter( (value) => value.GRUPOAPROVACAO == AL_COD )[0].APROVADORNEW = selectOption.value
        }

    return (    <SelectDinamico 
                    cValue="AK_COD"
                    cText="AK_NOME"
                    consulta={ConsultaAprovadores.consulta}
                    tabela={ConsultaAprovadores.tabelas}
                    isMultiplo={false}
                    onchange={(e) => handleChangeSelectAprovador(e, item.row.values.AL_COD)}
                />
    );
    }

    const handleTransferir = async() => {
        let aAprovadores = selectValues.filter((values) => values.APROVADORTIPO != '' && values.APROVADORTIPO != 'N' && values.APROVADORNEW != '');
        aAprovadores.map( (item) => {
            item.APROVADOROLD = aprovadorOrigem.value
        })

        if (aprovadorSCOrigem.value != "" && aprovadorSCDestino.value === "" ){
            ErroMsg("Favor preencher o Aprovador de SC de Destino!")
            return false;
        }

        setCarregar(true);

        const jsonTransferir = {
			APROVADORSCOLD: aprovadorSCOrigem.value,
			APROVADORSCNEW: aprovadorSCDestino.value,
			APROVADORES: aAprovadores,
		}

        let cJSONTransferir = JSON.stringify(jsonTransferir)
        
        const retornoAprovacao = await ConsumoTOTVS_POST( 'AJUSTA_APROVADOR', cJSONTransferir )

        setCarregar(false);
        if (retornoAprovacao.error != '00'){
            ErroMsg('Falha no processo de Ajuste de Aprovadores! Realizamos a comunicação do Depto de TI para correção.');
        }else{
            SucessoMsg("Ajuste dos Aprovadores realizado com sucesso!");
        }

        processaConsulta()
    }
    
    const processaConsulta = async() => {
        selectValues = [];
        let cConsulta = GrupoAprovacao.consulta;
        cConsulta += " AND AL_APROV = '" + aprovadorOrigem.value + "'"

        if (!aprovadorOrigem.value){
            //Limpa a variavel de Listagem
            setDataGrupoAprovacao([])
        }else{
            var retConsulta = await ConsultaTotvsEmpresa( cConsulta, GrupoAprovacao.tabelas );
            setDataGrupoAprovacao(retConsulta.data)
        }
    }

    useEffect( () => {
        processaConsulta()
    },[aprovadorOrigem])

    const columns = [
        {
            Header: 'Código',
            accessor: 'AL_COD'
        },
        {	
            Header: 'Grupo',
            accessor: 'AL_DESC'
        },
        {	
            Header: 'Manutencao',
            accessor: '',
            Cell: formatColumnManutencao
        },
        {	
            Header: 'Novo Aprovador',
            accessor: '',
            Cell: formatColumnNewAprovador
        }
    ]

    return (
		<>
            <LoadingSpinner isLoading={carregar}/>
			<Row>
				<Col md="12" xs="12">
					<TitlePage 
						text="Ajuste de Aprovadores"
					/>
				</Col>
				<Col md="4" xs="12">
					<SelectDinamico
                        label="Aprovador de SC - Origem"
                        campoValue={aprovadorSCOrigem}
                        value={aprovadorSCOrigem}
                        cValue="ZT1_CODIGO"
                        cText="ZT1_NOME"
                        consulta={ConsultaAprovadorSC.consulta}
                        tabela={ConsultaAprovadorSC.tabelas}
                        isMultiplo={false}
                        onchange={(e) => setAprovadorSCOrigem(e)}
                    />
				</Col>
                <Col md="4" xs="12">
                    <IconTransfer />
                </Col>
				<Col md="4" xs="12">
					<SelectDinamico
                        label="Aprovador de SC - Destino"
                        campoValue={aprovadorSCDestino}
                        value={aprovadorSCDestino}
                        cValue="ZT1_CODIGO"
                        cText="ZT1_NOME"
                        consulta={ConsultaAprovadorSC.consulta}
                        tabela={ConsultaAprovadorSC.tabelas}
                        isMultiplo={false}
                        onchange={(e) => setAprovadorSCDestino(e)}
                    />
				</Col>
            </Row>
            <STituloDivider></STituloDivider>
            <Row>
                <Col md="12" xs="12">
					<SelectDinamico 
                        label="Aprovador Origem"
                        campoValue={aprovadorOrigem}
                        value={aprovadorOrigem}
                        cValue="AK_COD"
                        cText="AK_NOME"
                        consulta={ConsultaAprovadores.consulta}
                        tabela={ConsultaAprovadores.tabelas}
                        isMultiplo={false}
                        onchange={(e) => setAprovadorOrigem(e)}
                    />
				</Col>
            </Row>
            
            { aprovadorOrigem.value != '' && (
                <ResponsiveDataTable
                    columns={columns} 
                    data={dataGrupoAprovacao}
                    buttons={[]}
                    habilitaBuscar={false}
                />
            )}

            <Row className="d-flex align-content-end align-items-end justify-content-end">
                <Col md="2" xs="12" >
                    <Button variant="primary" onClick={handleTransferir} className="w-100">
                        Transferir
                    </Button>
                </Col>
            </Row>
				
		</>
	);
};

export default AjustaAprovadores;